import { render, staticRenderFns } from "./makeForm.vue?vue&type=template&id=c2a47f16&"
import script from "./makeForm.vue?vue&type=script&lang=js&"
export * from "./makeForm.vue?vue&type=script&lang=js&"
import style0 from "./makeForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports